import React, { useEffect, useState } from "react";
import Modal from "components/modal";
import { timezoneAbbreviationLabel } from "shared/helpers/user";

const ChangeModeratorModal = ({
  isOpen,
  onClose,
  onConfirm,
  projectName,
  participantId,
  startTime,
  endTime,
  timeZone,
  currentModeratorName,
  availableModerators = [],
  loading,
  submitting = false,
  formatDate,
  t,
}) => {
  const [selectedModeratorId, setSelectedModeratorId] = useState(null);

  useEffect(() => {
    if (!isOpen) {
      setSelectedModeratorId(null);
    }
  }, [isOpen]);

  const handleConfirm = () => {
    if (submitting) return;
    if (typeof onConfirm === "function" && selectedModeratorId != null) {
      onConfirm(selectedModeratorId);
    }
  };

  return (
    <Modal
      title="Change Moderator"
      isOpen={isOpen}
      onCancel={onClose}
      onSubmit={handleConfirm}
      shouldFocusAfterRender={false}
      submitBtnText="Assign moderator"
      cancelBtnText="Cancel"
      enableSubmit={selectedModeratorId != null && !submitting}
      enableCancel={!submitting}
      isSubmitting={submitting}
      className="change-moderator-modal"
    >
      <div className="change-moderator-modal-body">
        <div className="header-block">
          <div className="project-name">{projectName}</div>
          {participantId ? (
            <div className="participant-id">
              PARTICIPANT ID: #{participantId}
            </div>
          ) : null}
        </div>

        <div className="section timeslot">
          <div className="section-title">Timeslot</div>
          <div className="date-time">
            <span className="date">
              {formatDate ? formatDate(startTime, "ddd MMM. DD, YYYY") : ""}
            </span>
            <span className="bullet"> • </span>
            <span className="time strong">
              {`${formatDate ? formatDate(startTime, "h:mm A") : ""} - ${
                formatDate ? formatDate(endTime, "h:mm A") : ""
              }`}
            </span>
            <span className="tz"> {timezoneAbbreviationLabel(timeZone)}</span>
          </div>
          {currentModeratorName ? (
            <div className="current-moderator">
              Current moderator: <b>{currentModeratorName}</b>
            </div>
          ) : null}
        </div>

        <div className="section moderators">
          <div className="section-title">Select a moderator</div>
          {loading ? (
            <div className="loading-row">Loading available moderators…</div>
          ) : availableModerators.length === 0 ? (
            <div className="empty-row">
              No moderators are available for this time slot. Add availability
              for a moderator on this project, then try again.
            </div>
          ) : (
            availableModerators.map((item) => {
              const mod = item.moderator || item;
              const disabled = item.hasConflict > 0 || item.isAvailable === false;
              const isSelected = selectedModeratorId === mod.id;
              return (
                <label
                  key={mod.id}
                  className={`moderator-option ${isSelected ? "selected" : ""} ${
                    disabled ? "disabled" : ""
                  }`}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    padding: "11px 13px",
                    marginBottom: 8,
                    border: isSelected
                      ? "1px solid #2D90C0"
                      : "1px solid #dce0ea",
                    borderRadius: 8,
                    background: isSelected ? "#f0f8fc" : "#fff",
                    opacity: disabled ? 0.55 : 1,
                    cursor: disabled ? "not-allowed" : "pointer",
                  }}
                >
                  <input
                    type="radio"
                    name="change-moderator"
                    style={{ accentColor: "#2D90C0", width: 16, height: 16 }}
                    disabled={disabled}
                    checked={isSelected}
                    onChange={() => {
                      if (!disabled) setSelectedModeratorId(mod.id);
                    }}
                  />
                  <span
                    className="moderator-name"
                    style={{ flex: 1, fontSize: 14, fontWeight: 600 }}
                  >
                    {`${mod.firstName} ${mod.lastName}`}
                  </span>
                  <span
                    className="moderator-status"
                    style={{
                      fontSize: 11,
                      fontWeight: 700,
                      letterSpacing: "0.04em",
                      textTransform: "uppercase",
                      padding: "2px 8px",
                      borderRadius: 10,
                      color: disabled ? "#8a8f9c" : "#2e9e6b",
                      background: disabled ? "#eef0f4" : "#e7f6ee",
                    }}
                  >
                    {disabled ? "Conflict" : "Available"}
                  </span>
                </label>
              );
            })
          )}
        </div>
      </div>
    </Modal>
  );
};

export default ChangeModeratorModal;
